

import { h } from 'preact';

export default function (props) {
    var styles = props.styles;
    var rest = Object.assign({}, props);
    delete rest.styles;

    return h('svg', Object.assign({"width":"13","height":"13","viewBox":"0 0 13 13","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, rest), ["\n", h('path', {"d":"M11.8652 0.615479L11.0742 2.34399L9.375 3.13501L11.0742 3.92603L11.8652 5.62524L12.6562 3.92603L14.3848 3.13501L12.6562 2.34399L11.8652 0.615479ZM5.625 2.49048L4.07227 5.94751L0.615234 7.50025L4.07227 9.05298L5.625 12.51L7.17773 9.05298L10.6348 7.50025L7.17773 5.94751L5.625 2.49048ZM11.8652 9.37524L11.0742 11.0745L9.375 11.8655L11.0742 12.6565L11.8652 14.385L12.6562 12.6565L14.3848 11.8655L12.6562 11.0745L11.8652 9.37524Z","fill":"#545B68"}, []), "\n"]);
};

        